<template>
  <app-content>

    <div class="flex flex-sb-c">
      <h1>Hej {{ userState.user.name.split(' ')[0] }}</h1>
      <AppButton color="error" icon="logout" @click="signOut">Log ud</AppButton>
    </div>
    <p v-if="userState.subscription.active">Du har <b>{{ userState.subscription.plan.name }}</b> </p>
    <p v-else>
      Du har lige nu <b>{{ userState.subscription.plan.name }}</b>.
      <span v-if="userState.subscription.expiring">Men det udløber inden længe!</span>
      Opgradér dit abonnement, for at få adgang til flere funktioner.
    </p>

    <br><br>


    <h2>{{ $t('nav.subscription') }}</h2>

    <SubscriptionPlans />

    <br>
    <AppButton class="color-primary" @click="manage" v-if="userState.user.customerId">Se faktura og ret betalingsoplysninger</AppButton>


    <Modal v-model="state.managing">
      <div class="text-c"> 
        <AppLoader />
        <h2>{{ $t('subscription.modal_redirect_title') }}</h2>
        <p>{{ $t('subscription.modal_redirect_desc') }}</p>
      </div>
    </Modal>

  </app-content>
</template>

<script lang="ts">
import { computed, defineComponent, reactive } from 'vue'
import SubscriptionPlans from '@/components/subscription/SubscriptionPlans.vue'
import { store } from '@/store'
import { redirectTomanageSubscription } from '@/api/tripply'

export default defineComponent({
  name: 'UserAccount',
  components: { SubscriptionPlans },
  setup() {
    const state = reactive({
      managing: false
    })
    const userState = store.user.get(state => state)

    function signOut() {
      store.auth.signOut()
    }

    async function manage() {
      state.managing = true
      await redirectTomanageSubscription()
    }

    return { state, userState, signOut, manage }
  }
})
</script>

<style lang="scss" scoped>

</style>